import { useState } from 'react';
import ScrollReveal from './ScrollReveal';

const faqs = [
  {
    q: '¿Necesito experiencia previa en Meta Ads?',
    a: 'No, el taller está diseñado para todos los niveles. Comenzamos desde los fundamentos más básicos y avanzamos progresivamente. Si ya tienes experiencia, encontrarás valor en los módulos avanzados y en la integración con IA.',
  },
  {
    q: '¿El acceso al taller es para siempre?',
    a: 'Sí, el acceso es de por vida. Puedes volver a consultar el contenido cuando quieras. Además, recibirás todas las actualizaciones futuras sin costo adicional.',
  },
  {
    q: '¿Cómo recibo el contenido después de la compra?',
    a: 'El contenido se entrega a través de Hotmart. Recibirás acceso inmediato a la plataforma con todos los módulos, bonos y materiales descargables.',
  },
  {
    q: '¿Qué herramientas de IA necesito?',
    a: 'Te enseñaremos a usar herramientas gratuitas y de bajo costo. No necesitas suscripciones costosas. Trabajaremos con ChatGPT, herramientas de generación de imágenes y otras plataformas accesibles.',
  },
  {
    q: '¿Puedo pagar desde cualquier país?',
    a: 'Sí, Hotmart acepta pagos internacionales con múltiples métodos: tarjeta de crédito, débito, PayPal y otros medios locales según tu país.',
  },

];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-20 md:py-28 bg-[#F7F8FA]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#C8A24A] mb-3">
              Dudas
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
              Preguntas Frecuentes
            </h2>
          </div>
        </ScrollReveal>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <ScrollReveal key={idx} delay={idx * 50}>
              <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden transition-all duration-300 hover:border-gray-200">
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <span className="font-heading text-[15px] md:text-base font-semibold text-[#111111] pr-4">
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    openIndex === idx
                      ? 'bg-[#E53935] text-white rotate-45'
                      : 'bg-[#F7F8FA] text-[#888888]'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 ease-out overflow-hidden ${
                    openIndex === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-[#666666] leading-relaxed">
                    {faq.a}
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}